import { createModel } from "@rematch/core";
import { CustomerContactsInterval, CustomerContactsState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const getInitValuesGroupNbaTopTenByOfferAddressed = () => ({
  offerAddressed: {
    countMatrix: [],
    groups: [],
    nbaNames: [],
  },
  offerAccepted: {
    countMatrix: [],
    groups: [],
    nbaNames: [],
  },
});

const initialState: CustomerContactsState = {
  interval: "week",
  countNbaTopTenByOfferAddressed: {
    offerAddressed: {
      countArray: [],
      nbaNames: [],
    },
    offerAccepted: {
      countArray: [],
      nbaNames: [],
    },
    ageGroup: getInitValuesGroupNbaTopTenByOfferAddressed(),
    clvGroup: getInitValuesGroupNbaTopTenByOfferAddressed(),
    churnScoreGroup: getInitValuesGroupNbaTopTenByOfferAddressed(),
    postcodeTopTenGroup: getInitValuesGroupNbaTopTenByOfferAddressed(),
  },
  countTotal: {
    count: 0,
    countWithNba: 0,
    countOfferAddressed: 0,
  },
  countPerInterval: [],
  loading: true,
};

export const customerContacts = createModel<RootModel>()({
  state: initialState as CustomerContactsState,
  reducers: {
    fetchPending(state) {
      return { ...state, loading: true };
    },
    fetchSuccess(state, payload: Partial<CustomerContactsState>) {
      return {
        ...state,
        ...payload,
        loading: false,
      };
    },
    fetchFail(state) {
      return { ...state, loading: false };
    },
  },
  effects: (dispatch) => ({
    async fetchCustomerContacts(interval: CustomerContactsInterval, rootState) {
      dispatch.customerContacts.fetchPending();

      const token = checkToken(rootState, () =>
        dispatch.customerContacts.fetchFail()
      );
      if (!token) return;

      try {
        const customerContactsResult = await api.fetchCustomerContacts({
          token,
          interval,
        });
        dispatch.customerContacts.fetchSuccess(customerContactsResult.data);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.customerContacts.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/customerContacts.ts